// MAD TURBO — brand assets (client-provided) + curated stock images
export const brandAssets = {
  logoWordmark: "https://customer-assets-39nsmqrw.emergentagent.net/job_ecu-engineering-hub/artifacts/j34ls80a_logo%20su%20uzrasu%20%2B%2B%2B.webp",
  mascot: "https://customer-assets-39nsmqrw.emergentagent.net/job_81f0bc2a-ae1e-44f0-bcd4-28545f8bb988/artifacts/wh10taq9_mascot%20su%20uzrasu%20%2B.png",
  garage: "https://customer-assets-39nsmqrw.emergentagent.net/job_81f0bc2a-ae1e-44f0-bcd4-28545f8bb988/artifacts/hi3dy03s_garazas%20%2B.png",
  driftCar: "https://customer-assets-39nsmqrw.emergentagent.net/job_81f0bc2a-ae1e-44f0-bcd4-28545f8bb988/artifacts/32911p2u_masina%20%2B.png",
  eventBooth: "https://customer-assets-39nsmqrw.emergentagent.net/job_81f0bc2a-ae1e-44f0-bcd4-28545f8bb988/artifacts/tr2j8ppe_varzybos%20%2B.png",
};

// curated stock imagery — moody, technical, european luxury
export const stock = {
  heroCar: "https://images.pexels.com/photos/12066287/pexels-photo-12066287.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  laptopDiagnostics: "https://images.pexels.com/photos/10490631/pexels-photo-10490631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  engineDetails: "https://images.pexels.com/photos/35497785/pexels-photo-35497785.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  engineBay: "https://images.pexels.com/photos/17575953/pexels-photo-17575953.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
};

export const social = {
  facebook: "https://www.facebook.com/madturbo.lt/",
  instagram: "https://www.instagram.com/madturbo.lt/",
  whatsapp: "https://wa.me/37065857956",
  messenger: "https://m.me/madturbo.lt",
};

export const company = {
  name: "MAD TURBO",
  tagline: { lt: "Daugiau slėgio. Daugiau beprotybės.", en: "More Boost. More Madness." },
  phone: "+370 658 57956",
  phoneRaw: "+37065857956",
  email1: "zygimantas@madturbo.lt",
  email2: "nojus@madturbo.lt",
  location: { lt: "Šiauliai, Lietuva", en: "Šiauliai, Lithuania" },
  address: "Šiauliai, LT",
};
